import withLazy from '../../hoc/with-lazy';
const LikeMetadataLazy = withLazy({
    importFn: () => import(/* webpackChunkName: "wc-likes-metadata"*/ './likes-metadata'),
    errorHandling: { type: 'HANDLE' },
});
export default LikeMetadataLazy;
//# sourceMappingURL=likes-metadata-lazy.js.map